import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Näita vähem tootepilte

  <span style="color:#85c1dc;">**FI:**</span>
  Näytä vähemmän tuotekuvia

  <span style="color:#85c1dc;">**RU:**</span>
  Показывать меньше изображений товара
*/
/* @__NO_SIDE_EFFECTS__ */
const m285 = msg(
  mf`Näita vähem tootepilte`,
  mf`Näytä vähemmän tuotekuvia`,
  mf`Показывать меньше изображений товара`,
)

export { m285 as 'w.module.image_viewer.show_less_images' }